import { bootstrap } from '@ingresse/awa-analytics-web';
import * as Sentry from '@sentry/react';
import i18n from 'i18next';
import ReactDOM from 'react-dom/client';

// Import global styles and components
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import { Environment } from './constants/environments';
import RoutesApp from './routes/index.tsx';
import './styles/fonts.css';

// Initialize Sentry for error tracking
Sentry.init({
  dsn : 'https://ebf7672fc6cb6e4ec4e9d6323b596f19@o4508138191454208.ingest.us.sentry.io/4508167928545280',
  integrations : [],
});

// MKT-258 / MKT-490 — the SDK now OWNS analytics: given the deploy `env` it loads
// the right GTM container (which fans out to GA4 / Ads / the global Meta pixel +
// per-producer pixels), hydrates the shared `ingresse_consent` cookie and
// configures the server-side Meta CAPI. No banner is mounted here (embedded
// checkout). CAPI no-ops when the endpoint is empty, so it is safe to always pass it.
//
// MKT-483 — PostHog is now SDK-owned too: bootstrap inits the shared `posthog-js`
// singleton (consent-aware). The app's `PostHogProvider` (hooks/contexts) only
// re-exposes that SAME singleton to the `posthog-js/react` hooks — no second init.
// Key/host come from the app's env convention; omitted entirely when the key is unset.
bootstrap({
  env : Environment.NODE_ENV,
  posthog : Environment.PUBLIC_POSTHOG_KEY
    ? {
      apiKey : Environment.PUBLIC_POSTHOG_KEY,
      apiHost : Environment.PUBLIC_POSTHOG_HOST,
    }
    : undefined,
  consent : {},
  metaCapi : { endpoint : Environment.API_META_CONVERSIONS_URL },
  // Consent banner in the language the checkout is already showing. `i18n` is
  // initialized by `hooks/contexts/i18n.context`, which this module pulls in
  // transitively through `RoutesApp` — ESM evaluates that before this body runs,
  // so the detected language is available here. `I18nProvider` keeps it in step
  // from this point on.
  consentBanner : { locale : i18n.language },
});

// Render the React application
ReactDOM.createRoot(document.getElementById('root')!).render(<RoutesApp />);
